import { Navigate, useUserPermissions } from "@";

const CanShow = ({ page, ifHas = [] }) => {
  const { permissions } = useUserPermissions();

  if (!ifHas?.length) {
    return page;
  }

  const hasPermissions = ifHas.some(
    (permission) => permissions?.[permission],
  );

  if (hasPermissions) {
    return page;
  }

  return <Navigate to="/not-have-permissions" />;
};

export default CanShow;
